import { motion } from "framer-motion";

export default function PageHero({ eyebrow, title, description, image, breadcrumbs, testId = "page-hero" }) {
  return (
    <section
      data-testid={testId}
      className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden"
    >
      {image && (
        <div className="absolute inset-0 -z-0">
          <img
            src={image}
            alt=""
            aria-hidden
            className="h-full w-full object-cover opacity-[0.32]"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0F0F12]/30 via-[#0F0F12]/85 to-[#0F0F12]" />
        </div>
      )}
      <div className="absolute inset-0 blueprint-grid opacity-[0.05] -z-0" />
      <div className="absolute -top-40 right-0 h-[500px] w-[500px] orange-glow opacity-50 -z-0" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        {breadcrumbs && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="flex items-center gap-2 text-[11px] tracking-[0.3em] text-white/40 uppercase mb-6"
          >
            {breadcrumbs.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-[#C96A2B]">/</span>}
                {b}
              </span>
            ))}
          </motion.div>
        )}

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.05 }}
          className="eyebrow"
        >
          {eyebrow}
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1], delay: 0.1 }}
          className="font-display mt-6 text-5xl md:text-7xl lg:text-[88px] leading-[0.96] tracking-tight max-w-5xl"
        >
          {title}
        </motion.h1>

        {description && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="mt-8 text-white/65 max-w-2xl text-[15px] md:text-[17px] leading-[1.8]"
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
}
